import React from 'react';
import { WidgetStyles } from './types/styles';

export interface FSContextType {
    styles: WidgetStyles;
    inDesignMode?: boolean;
    hasProducts?: boolean;
    isPremiumWidget?: boolean;
    currentPageType?: string;
    openedMenuItemId?: string | null;
    toggleMenuItem: (id: string) => void;
}
export const FilterSortContext = React.createContext<FSContextType>({
    styles: {},
    openedMenuItemId: null,
    toggleMenuItem: () => {},
});

export function useFilterSortStyles() {
    return useFilterSortContext().styles;
}
export function useFilterSortContext() {
    return React.useContext(FilterSortContext);
}
